import get from 'lodash/get'
import isFunction from 'lodash/isFunction'
import isNil from 'lodash/isNil'
import keys from 'lodash/keys'
import reject from 'lodash/reject'
import some from 'lodash/some'

import { applyAnswerToResponse, removeErrorId } from './answers'
import { getMatrixCoordinateId } from './helpers'

export function setUpdatedMatrixCheckboxCell(
  prevCellQuestions,
  rowData,
  columnData
) {
  const rowId = getMatrixCoordinateId(rowData)
  const columnId = getMatrixCoordinateId(columnData)

  const hasAnswer = some(
    prevCellQuestions,
    (cell) =>
      cell.question_row?.id === rowId && cell.question_column?.id === columnId
  )

  return hasAnswer
    ? reject(
        prevCellQuestions,
        (cell) =>
          getMatrixCoordinateId(cell.question_row) === rowId &&
          getMatrixCoordinateId(cell.question_column) === columnId
      )
    : [
        ...prevCellQuestions,
        {
          question_column: columnData,
          question_row: rowData,
        },
      ]
}

export function setUpdatedGenericTableCell(
  prevCellQuestions,
  rowData,
  columnData
) {
  const rowId = getMatrixCoordinateId(rowData)
  const columnId = getMatrixCoordinateId(columnData)

  const elementInUpdatedList = prevCellQuestions?.find(
    (x) =>
      getMatrixCoordinateId(x.question_row) === rowId &&
      getMatrixCoordinateId(x.question_column) === columnId
  )
  if (elementInUpdatedList === undefined) {
    return [
      ...prevCellQuestions,
      {
        question_column: columnData,
        question_row: rowData,
      },
    ]
  }

  return prevCellQuestions
}

export function answerCellChangeHelper({
  isOfficeUseForm,
  isOfficeUseQuestion,
  response,
  setResponse,
  question,
  rowData,
  columnData,
  value,
  setAllDirty,
  setAnswerErrors,
  updatedCellQuestions,
  source,
}) {
  if (isOfficeUseForm !== isOfficeUseQuestion) {
    return updatedCellQuestions
  }

  setResponse(
    applyAnswerToResponse(response, question, {
      rowData,
      columnData,
      value,
    })
  )

  isFunction(setAllDirty) && setAllDirty(false)
  isFunction(removeErrorId) && removeErrorId(question, setAnswerErrors)

  if (question.question_type.question_subtype === 'checkbox') {
    return setUpdatedMatrixCheckboxCell(
      updatedCellQuestions,
      rowData,
      columnData
    )
  }

  return setUpdatedGenericTableCell(updatedCellQuestions, rowData, columnData)
}

export function saveResponseErrorHelper(
  answerErrors,
  setAnswerErrors,
  setQuestionIdToScroll
) {
  if (!isNil(answerErrors)) {
    setAnswerErrors(answerErrors)
    const errorIdToScroll = get(keys(answerErrors), 0)
    errorIdToScroll && setQuestionIdToScroll(errorIdToScroll)
  }
}

export function handleConditionalAnswerRemoval(
  question,
  onAnswerChanged,
  onAnswerCellChanged,
  onAnswerSignatureChanged
) {
  if (question.question_type.question_type === 'checkbox') {
    for (const choice of question.question_choices) {
      onAnswerChanged(question, { value: false, choiceId: choice.id })
    }
    return
  }

  if (question.question_type.question_type === 'radio') {
    return onAnswerChanged(question, { choiceId: '', textDetails: null })
  }

  if (
    question.question_type.question_type === 'text' ||
    question.question_type.question_type === 'datetime' ||
    question.question_type.question_type === 'number'
  ) {
    return onAnswerChanged(question, '')
  }

  if (question.question_type.question_type === 'file_upload') {
    return onAnswerChanged(question, null)
  }

  if (question.question_type.question_type === 'signature') {
    return onAnswerSignatureChanged(question, {
      image: null,
      text: '',
      ip: null,
    })
  }

  if (
    question.question_type.question_type === 'matrix' ||
    question.question_type.question_type === 'table'
  ) {
    return onAnswerCellChanged?.(question, null, null)
  }
}
